import React from 'react';
import PropTypes from 'prop-types';
import FilterType from './FilterType';
import FilterDetailInput from "./filter/FilterDetailInput";
import FilterDetailSelect from "./filter/FilterDetailSelect";
import FilterDetailDateRange from "./filter/FilterDetailDateRange";
import DelayedInput from "../higher-order/DelayedInput";

const propTypes = {
	// columnInformation being filtered
	columnInformation: PropTypes.object.isRequired,

	// override for filter icon
	filterIcon: PropTypes.func,

	// what type of filtering to use FilterType...
	filterType: PropTypes.oneOf(Object.values(FilterType)),

	// if select is the type of filter then provide list of filters to use
	filterTypeOptions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.any.isRequired
		})),

	// onChange callback (columnInformation, value) => do whatever you want
	onChange: PropTypes.func.isRequired,

	// the value to show in the text input or select
	value: PropTypes.any,
};

const defaultProps = {
	filterIcon: undefined,
	filterType: undefined,
	filterTypeOptions: undefined,
	value: undefined
};

export default class Filter extends React.Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);

		this.delayedFilterDetailInput = DelayedInput(FilterDetailInput);
		this.delayedFilterDetailSelect = DelayedInput(FilterDetailSelect);
		this.delayedFilterDetailDateRange = DelayedInput(FilterDetailDateRange);
		this.delayLength = 250;
	}

	onChange(field, value) {
		this.props.onChange(this.props.columnInformation, value);
	}

	render() {
		let filterInput;

		switch (this.props.filterType) {
			default:
			case FilterType.INPUT:
				filterInput = <this.delayedFilterDetailInput
					columnInformation={this.props.columnInformation}
					onChange={this.onChange}
					value={this.props.value}
					timeoutLength={this.delayLength}
					filterIcon={this.props.filterIcon}
				/>;
				break;

			case FilterType.SELECT_MULTI:
				filterInput = <this.delayedFilterDetailSelect
					filterTypeOptions={this.props.filterTypeOptions}
					onChange={this.onChange} value={this.props.value}
					isMultiSelect={true}
					timeoutLength={this.delayLength}
				/>;
				break;
			case FilterType.SELECT:
				filterInput = <this.delayedFilterDetailSelect
					filterTypeOptions={this.props.filterTypeOptions}
					onChange={this.onChange}
					value={this.props.value}
					timeoutLength={this.delayLength}
				/>;
				break;

			case FilterType.DATE_RANGE:
				filterInput = <this.delayedFilterDetailDateRange
					onChange={this.onChange}
					value={this.props.value}
					timeoutLength={this.delayLength}
					filterIcon={this.props.filterIcon}
				/>;
				break;
		}

		return <td>{filterInput}</td>;
	}
}

Filter.defaultProps = defaultProps;
Filter.propTypes = propTypes;
